import { render, staticRenderFns } from "./NsFeature.vue?vue&type=template&id=cf32b3a2&"
import script from "./NsFeature.vue?vue&type=script&lang=js&"
export * from "./NsFeature.vue?vue&type=script&lang=js&"
import style0 from "./NsFeature.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports